export default "__VITE_ASSET__CRcjtNsn__"